<div class="label-container">
  <div {{#if theme_class}}class="{{theme_class}}"{{/if}}>
    {{#with icon}}
      {{#if class}}
        {{>icon uuid=../cid prefix=../iconPrefix name=../iconType }}
      {{/if}}
    {{/with}}
    {{#if newIcon}}
      {{>icon uuid=cid icon=icon }}  
    {{/if}}
    <label {{#if text_class}}class="{{text_class}}"{{/if}}>{{t description}}</label>
  </div>
</div>
